<template>
    <div
        :class="[
            'file-upload-drag-n-drop',
            {
                'file-upload-drag-n-drop--active': isDragging,
                'file-upload-drag-n-drop--disabled': disabled,
            },
        ]"
        @dragenter.prevent="onDragEnter"
        @dragleave.prevent="onDragLeave"
        @dragover.prevent
        @drop.prevent="onDrop"
    >
        <v-file-input
            :accept="accept"
            :disabled="disabled"
            :label="label"
            :placeholder="placeholder"
            v-model="innerValue"
        >
            <template slot="append-outer">
                <slot name="append-outer"></slot>
            </template>
        </v-file-input>
    </div>
</template>

<script>
export default {
    name: "FileUploadDragNDrop",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        accept: {
            type: String,
            default: undefined,
        },
        label: {
            type: String,
            default: undefined,
        },
        placeholder: {
            type: String,
            default: undefined,
        },
        value: {
            type: File,
            default: null,
        },
    },
    data() {
        return {
            isDragging: false,
            dragCounter: 0,
        };
    },
    computed: {
        innerValue: {
            get() {
                return this.value;
            },
            set(file) {
                this.$emit("input", file || null);
            },
        },
    },
    methods: {
        onDragEnter() {
            if (this.disabled) return;
            this.dragCounter++;
            this.isDragging = true;
        },
        onDragLeave() {
            if (this.disabled) return;
            this.dragCounter--;
            if (this.dragCounter <= 0) {
                this.dragCounter = 0;
                this.isDragging = false;
            }
        },
        onDrop(event) {
            this.dragCounter = 0;
            this.isDragging = false;
            if (this.disabled) return;

            const files = event.dataTransfer && event.dataTransfer.files;
            if (!files || files.length === 0) return;

            const file = files[0];
            if (this.accept && !this.isFileAccepted(file)) return;

            this.innerValue = file;
        },
        isFileAccepted(file) {
            const acceptedTypes = this.accept
                .split(",")
                .map(type => type.trim())
                .filter(Boolean);

            if (acceptedTypes.length === 0) return true;

            return acceptedTypes.some(type => {
                if (type.startsWith(".")) {
                    return file.name.toLowerCase().endsWith(type.toLowerCase());
                }
                if (type.endsWith("/*")) {
                    return file.type.startsWith(type.slice(0, -1));
                }
                return file.type === type;
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
.file-upload-drag-n-drop
    border-radius 4px
    border 2px dashed transparent
    transition border-color 0.2s ease, background-color 0.2s ease

    &--active
        border-color var(--v-primary-base, #1976d2)
        background-color rgba(25, 118, 210, 0.06)

    &--disabled
        pointer-events none
</style>
